import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_DEPOT_SCHEMA_LITERAL = {
    title: 'Schéma dépôts',
    description: 'Décrit les dépôts',
    version: 0,
    keyCompression: false,
    primaryKey: 'DE_NO_STR',
    type: 'object',
    properties: {
        DE_NO_STR: { type: 'string', maxLength : 10 },
        DE_NO: { type: 'number' },
        DE_CODE: { type: 'string' },
        DE_INTITULE: { type: 'string' },
        DE_PRINCIPAL: { type: 'number' },
        DE_PRINCIPAL_LIB: { type: 'string' },
        DE_ADRESSE: { type: ['string', 'null'] },
        DE_COMPLEMENT: { type: ['string', 'null'] },
        DE_CODEPOSTAL: { type: ['string', 'null'] },
        DE_VILLE: { type: ['string', 'null'] },
        DE_PAYS: { type: ['string', 'null'] },
        DE_EMAIL: { type: ['string', 'null'] },
        DE_CONTACT: { type: ['string', 'null'] },
        DE_TELEPHONE: { type: ['string', 'null'] },
        DE_TELECOPIE: { type: ['string', 'null'] },
        DE_CATCOMPTA: { type: 'number' },
        DE_PRINCIPAL_PSITE: { type: 'boolean' },
        DE_PRINCIPAL_F: { type: 'boolean' }
    },
    required: [ 'DE_NO', 'DE_INTITULE', 'DE_PRINCIPAL', 'DE_PRINCIPAL_PSITE', 'DE_PRINCIPAL_F' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_DEPOT_SCHEMA_LITERAL);
export type RxFDepotDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_DEPOT_SCHEMA: RxJsonSchema<RxFDepotDocumentType> = F_DEPOT_SCHEMA_LITERAL;
